import React from "react";
import {Button, Table} from "react-bootstrap";

class InstallationsTable extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <div>
                <Table bordered responsive>
                    <thead>
                    <tr>
                        <th>AffID</th>
                        <th>SubID</th>
                        <th>Country</th>
                        <th>IP</th>
                        <th>ClickID</th>
                        <th>DeviceID</th>
                        <th>Payout</th>
                        <th>Date</th>
                        <th>Actions</th>
                    </tr>
                    </thead>

                    <tbody>
                    {
                        this.props.installations.map(({ affid, subid, country, ip, clickId, deviceId, payout, date }) => {
                            return (
                                <tr>
                                    <th>{affid}</th>
                                    <th>{subid}</th>
                                    <th>{country}</th>
                                    <th>{ip}</th>
                                    <th>{clickId}</th>
                                    <th>{deviceId}</th>
                                    <th>{payout}</th>
                                    <th>{date}</th>
                                    <th style={{ width: '1%', whiteSpace: 'nowrap' }}>
                                        <Button bsStyle={'danger'} onClick={() => this.props.onRemove(deviceId)}>Remove</Button>
                                    </th>
                                </tr>
                            )
                        })
                    }
                    </tbody>
                </Table>
            </div>
        );
    }
}

export default InstallationsTable


// WEBPACK FOOTER //
// ./src/scenes/ApkInstallations/components/InstallationsTable/index.js